import React, { useEffect, useState } from "react";
import { KSLiveBannerCard } from "../Homepage/KSLiveBanner";
import { CONVEX_API_URL } from "../../../config/config";

import "./styles.scss";

const KSLiveExitIntentPopup = (props) => {
  const { show: showModal, handleClose } = props;
  const [activeEvents, setActiveEvents] = useState([]);


  useEffect(() => {
    const fetchActiveEvents = async () => {
      try {
        const url = `${CONVEX_API_URL}/program/null/campaign/null/events/popup-session`;

        const res = await fetch(url);
        const data = await res.json();

        if (res.ok && res.status === 200) setActiveEvents(data);
        
      } catch (error) {
        console.log(error);
      }
    };

    fetchActiveEvents();
  }, []);




  // for exit intent

  useEffect(() => {
    if (activeEvents.length === 0) return;

    // if show modal is true check for session storage
    if (showModal) {
      const liveRegistrationPopup = document.querySelector("#ks-live-popup");

      //if -> form page
      if(window.location.pathname.includes('content-writing-course') ||
      window.location.pathname.includes('marketing-launchpad') || 
      window.location.pathname.includes('sales-course') ||
      window.location.pathname.includes('digital-marketing-course-in-hindi') ||
      window.location.pathname.includes('kraftshala-live')
      ) {
        return;
      } else if (liveRegistrationPopup) {
        liveRegistrationPopup.showModal();
      }
    }
  }, [showModal]);

  function handlePopUpClose() {
    if (!showModal) return;
    const contactUsDialog = document.querySelector("#ks-live-popup");

    if (contactUsDialog) {
      contactUsDialog.close();
    }

    handleClose();
  }

  if (!activeEvents.length) return null;

  return (
    <React.Fragment>
      <dialog id="ks-live-popup">
        <KSLiveBannerCard
          activeEvents={activeEvents}
          isPopup={true}
          onClickOutside={handlePopUpClose}
        >
          <button
            autoFocus={false}
            className="dialog-toggle-btn"
            onClick={handlePopUpClose}
          >
            {" "}
            ✕{" "}
          </button>
        </KSLiveBannerCard>
      </dialog>
    </React.Fragment>
  );
};

export default KSLiveExitIntentPopup;
